import { useCallback } from "react";
import { Mission } from "../../__generated__/graphql";
import { useI18n } from "../i18n-hooks";
import { useSnackbar } from "../snackbar";
import { addToCalendar } from "./addToCalendar";
import { Linking } from "react-native";
import { CalendarDialogResultActions, PermissionStatus } from "expo-calendar";

export const useAddMissionToCalendar = () => {
    const i18n = useI18n();
    const { showSnackbar } = useSnackbar();
    return useCallback(
        async (mission: Mission) => {
            const contract = mission.currentContract;
            if (!contract) {
                return;
            }
            if (!contract.startDate) {
                return;
            }
            const jobTitle = contract?.jobTitle || mission.activityType?.title || "";
            const title = i18n.t("calendar.mission_title", { title: jobTitle });
            const location = contract.workingAddress?.formatted;
            const notes = i18n.t("calendar.mission_notes", {
                client: mission.clientInfo.name,
                worker: mission.workerInfo.name,
                title: jobTitle,
            });
            try {
                const action = await addToCalendar({
                    title,
                    startDate: new Date(contract.startDate).toISOString(),
                    endDate: contract.endDate
                        ? new Date(contract.endDate).toISOString()
                        : new Date(contract.startDate).toISOString(),
                    location,
                    notes,
                });

                switch (action) {
                    case CalendarDialogResultActions.saved:
                        showSnackbar({
                            text: i18n.t("calendar.mission_added"),
                            mode: "success",
                        });
                        return true;
                        break;
                    case PermissionStatus.DENIED:
                        showSnackbar({
                            text: i18n.t("permission_denied"),
                            mode: "error",
                        });
                        await Linking.openSettings();
                        break;
                    default:
                        break;
                }
                return false;
            } catch (e) {
                showSnackbar({
                    text: i18n.t("calendar.error_adding"),
                    mode: "error",
                });
            }
        },
        [i18n, showSnackbar],
    );
};
